// src/config.ts
export const API_BASE_URL = window.location.hostname === 'flabs2fabs.omchat.ovh' 
  ? 'https://flabs2fabs.omchat.ovh'
  : 'http://localhost:8008';

export const API_CONFIG = {
  headers: () => {
    const token = localStorage.getItem('flab2fabs_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }
};
